import { ApplicationRef, Injectable, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemingService implements OnDestroy {
  public currentTheme: string;
  public theme = new BehaviorSubject('theme-default');
  public themes = ['theme-blue-gray-dark', 'theme-default'];

  private _mediaQuery: MediaQueryList;
  private _mediaQueryListener: () => void;
  private _subscription: Subscription;
  private ref = inject(ApplicationRef);

  public constructor() {
    this._mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    this._mediaQueryListener = () => this.handleMediaQueryChange();
    this._subscription = new Subscription();

    // Initially check if dark mode is enabled on the system
    const darkModeOn = this._mediaQuery.matches;

    if (darkModeOn) {
      this.currentTheme = 'theme-blue-gray-dark';
      this.theme.next(this.currentTheme);
    }

    // Watch for changes of the preference
    if (this._mediaQuery.addEventListener) {
      console.info('ThemingService: Listening to the operating system theme with addEventListener');
      this._subscription.add(this._mediaQuery.addEventListener('change', this._mediaQueryListener));
    } else {
      // Try the deprecated addListener. old versions of Safari doesn't support addEventListener.
      if (this._mediaQuery.addListener) {
        console.info('ThemingService: Listening to the operating system theme with addListener');
        this._subscription.add(this._mediaQuery.addListener(this._mediaQueryListener));
      } else {
        console.warn('ThemingService: This browser does not support listening to changes in the operating system theme.');
      }
    }
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private handleMediaQueryChange(): void {
    const darkModeOn = this._mediaQuery.matches;
    this.currentTheme = darkModeOn ? 'theme-blue-gray-dark' : 'theme-default';
    this.theme.next(this.currentTheme);
    this.ref.tick();
  }
}
